import { CMS_ROUTES } from "../../Constant";

/**
 * AuthProvider is mounted on public pages too. Missing localStorage must not
 * bounce /whitelist-login (or other CMS routes) back to /members.
 */
export function shouldRedirectForMissingSession(pathname, userId, token) {
  const path = String(pathname || "/").split("?")[0];
  const firstSegment = path.split("/")[1] || "";
  if (CMS_ROUTES.includes(path)) return false;
  if (firstSegment === "password-recovery" || firstSegment === "thankyou") {
    return false;
  }
  return userId === null && token === null;
}
